/**
 * PostHog Analytics Events for Activity Panel Features
 * Tracks: Activity pinning, Notes panel, Activity filtering
 */

// Event names
export const ACTIVITY_PANEL_EVENTS = {
  // Pin events
  ACTIVITY_PINNED: 'activity_pinned',
  ACTIVITY_UNPINNED: 'activity_unpinned',

  // Notes events
  NOTES_PANEL_OPENED: 'notes_panel_opened',
  NOTE_CREATED: 'note_created',
  NOTE_DELETED: 'note_deleted',

  // Activity filter events
  ACTIVITY_FILTER_TOGGLED: 'activity_filter_toggled',
  ACTIVITY_FILTERS_CLEARED: 'activity_filters_cleared',
} as const;

// Property names
export const ACTIVITY_PANEL_PROPERTIES = {
  // Common
  MATTER_ID: 'matter_id',
  PAGE: 'page',
  COMPONENT: 'component',

  // Pin properties
  ACTIVITY_ID: 'activity_id',
  ACTIVITY_TYPE: 'activity_type', // event_code like 'matter_created', 'task_status_changed'
  PINNED_COUNT: 'pinned_count', // total pinned after action

  // Notes properties
  NOTES_COUNT: 'notes_count', // existing notes count
  HAS_MENTIONS: 'has_mentions',
  MENTION_COUNT: 'mention_count',
  CHARACTER_COUNT: 'character_count', // rough length, not content

  // Filter properties
  FILTER_KEY: 'filter_key', // MATTER, TASK, TREATMENT
  FILTER_ACTION: 'filter_action', // 'added' or 'removed'
  ACTIVE_FILTERS: 'active_filters', // array of active filter keys
  ACTIVE_FILTER_COUNT: 'active_filter_count',
} as const;

// Type helpers
export type ActivityPanelEvent =
  (typeof ACTIVITY_PANEL_EVENTS)[keyof typeof ACTIVITY_PANEL_EVENTS];
export type ActivityPanelProperty =
  (typeof ACTIVITY_PANEL_PROPERTIES)[keyof typeof ACTIVITY_PANEL_PROPERTIES];
